import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App/App';

// Ant Design
import { ConfigProvider } from 'antd';
import theme from './theme/theme.json';

// Redux
import store from './store';
import { Provider } from 'react-redux';

// Suppress cross-origin "Script error." overlay in development (e.g. from AdSense/Adblocker/Iframes/Print)
if (process.env.NODE_ENV === 'development') {
  window.addEventListener(
    'error',
    (event) => {
      if (
        event.message === 'Script error.' ||
        event.message === 'Script error' ||
        !event.filename
      ) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    },
    true
  );

  const prevOnError = window.onerror;
  window.onerror = function (message, source, lineno, colno, error) {
    if (message === 'Script error.' || message === 'Script error' || !source) {
      return true; // Suppress React error overlay for cross-origin / third-party script errors
    }
    if (typeof prevOnError === 'function') {
      return prevOnError.apply(this, arguments);
    }
    return false;
  };

  window.addEventListener(
    'unhandledrejection',
    (event) => {
      if (
        event.reason &&
        (event.reason.message === 'Script error.' ||
          event.reason.message === 'Script error')
      ) {
        event.stopImmediatePropagation();
        event.preventDefault();
      }
    },
    true
  );
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ConfigProvider theme={theme}>
    <Provider store={store}>
      <App />
    </Provider>
  </ConfigProvider>
);